var map = {
	"./de/general2/slide1.svg": 894583,
	"./en/general2/slide1.svg": 224195,
	"./es/general2/slide1.svg": 302894,
	"./fr/general2/slide1.svg": 299526,
	"./nl/general2/slide1.svg": 595596,
	"./pt/general2/slide1.svg": 346418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 532785;